var render = function render(){var _vm=this,_c=_vm._self._c;return _c('btndrop',{attrs:{"value":_vm.isReconciled,"onLabel":"Reconciled","offLabel":"Not Reconciled","onchange":_vm.updateReconciled}})
}
var staticRenderFns = []

export { render, staticRenderFns }